var map = {
	"./default.vue": [
		"7b3d",
		"chunk-c45d5bd4"
	],
	"./home.vue": [
		"0f93",
		"chunk-2d0af8c6"
	],
	"./newdefault.vue": [
		"b5e7",
		"chunk-c0676ce6"
	],
	"./user.vue": [
		"1a2a",
		"chunk-668e8d3e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a449";
module.exports = webpackAsyncContext;